import React, { useContext, useEffect, useState } from 'react';
import SinglePageForm, {
    getEmailRules,
    getPasswordRules,
} from '../common/SinglePageForm';
import { Input, Button, Alert, Form } from 'antd';
import { UnauthorizedApiError } from '../services/error';
import { APP_CCX, CustomAppContext } from '../common/CustomAppContext';
import './AdminLoginPage.less';
import { trackCustomEvent } from '../helpers';

export default AdminLoginPage;

/**
 * @name AdminLogin
 * @desc AdminLogin component.
 */
function AdminLoginPage() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { currentApp } = useContext(CustomAppContext);

    const {
        getCustomAppButtonStyle,
        getCustomAppAdminRedirectUrl,
        adminLogin,
    } = useContext(CustomAppContext);

    /**
     * @name handleSubmit
     * @desc Handles form submit.
     * @private
     */
    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            await adminLogin(values);
            window.location.assign(getCustomAppAdminRedirectUrl());
            trackCustomEvent(currentApp, 'admin_login_success', 'click');
        } catch (err) {
            if (err instanceof UnauthorizedApiError) {
                setError('Incorrect username or password');
            } else {
                setError(err.message);
            }
            trackCustomEvent(currentApp, 'admin_login_failed', 'click');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
        trackCustomEvent(currentApp, 'Admin_Login_Error', 'click');
        setError('Please check your input and try again.');
    };

    return (
        <SinglePageForm
            form={form}
            onFinish={handleSubmit}
            onFinishFailed={handleSubmitFailed}
            data-testid="login-form"
        >
            <SinglePageForm.Content>
                <h1 className="AdminLoginPage-form-title">Admin Log in </h1>
                {error ? (
                    <Alert
                        message={
                            <span className="AdminLoginPage-error-message">
                                {error}
                            </span>
                        }
                        description={
                            <span className="AdminLoginPage-error-description">
                                Please try again.
                            </span>
                        }
                        type="error"
                        showIcon
                    />
                ) : null}
                <Form.Item
                    label="Email"
                    name="login"
                    rules={getEmailRules()}
                    validateTrigger="onBlur"
                >
                    <Input
                        data-testid="login-form-input-email"
                        disabled={loading}
                        placeholder="Enter your email"
                    />
                </Form.Item>
                <Form.Item
                    label="Password"
                    name="password"
                    rules={getPasswordRules()}
                    validateTrigger="onBlur"
                >
                    <Input.Password
                        data-testid="login-form-input-password"
                        disabled={loading}
                        placeholder="Enter your password"
                    />
                </Form.Item>
                <SinglePageForm.Footer>
                    <Button
                        data-testid="login-form-button-submit"
                        loading={loading}
                        type="primary"
                        htmlType="submit"
                        className="AdminLoginPage-form-button"
                        style={getCustomAppButtonStyle()}
                    >
                        Log in
                    </Button>
                </SinglePageForm.Footer>
            </SinglePageForm.Content>
        </SinglePageForm>
    );
}
